export const workingHours = 40;
export const workingDays = 5;
export const hourlyRate = 20;
export const regularHourRate = 40;
